import { $svg, UISVG } from '../svg';
import { UIClassesSpec } from '../types';
import { UIView } from '../view';

export class UIProgressWheel extends UIView {
    private _progress: number | undefined;
    private _circle: SVGCircleElement;;

    constructor(classes?: UIClassesSpec) {
        super('div', ['ui-progress-wheel', classes]);

        const svg = new UISVG(undefined, [96, 96]);

        svg.add($svg.CIRCLE(48, 48, 40, 'r-back'))
        svg.add(this._circle = $svg.CIRCLE(48, 48, 40, 'r-progress'));

        this.ui_add(svg);

        this.progress = 0;
    }

    set progress(p: number | undefined) {
        if(p === this._progress) return;
        this._progress = p;
        this.classList.toggle('f-undefined', p == null);

        if(p == null)
            this._circle.style.strokeDashoffset = '';
        else
            this._circle.style.strokeDashoffset = '' + (251.3274 * (1 - p));
    }
}

export class UIProgressBar extends UIView {
    private _progress: number | undefined;
    private _circle: SVGCircleElement;;

    constructor() {
        super('div', 'ui-progress-wheel');

        const svg = new UISVG(undefined, [96, 96]);
        svg.add($svg.CIRCLE(48, 48, 40, 'r-back'))
        svg.add(this._circle = $svg.CIRCLE(48, 48, 40, 'r-progress'));

        this.ui_add(svg);

        this.progress = 0;
    }

    set progress(p: number | undefined) {
        if(p === this._progress) return;
        this._progress = p;
        this.classList.toggle('f-undefined', p == null);

        if(p == null)
            this._circle.style.strokeDashoffset = '';
        else
            this._circle.style.strokeDashoffset = '' + (251.3274 * (1 - p));
    }
}
